import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "el-time-range-picker el-picker-panel"
}
const _hoisted_2 = { class: "el-time-range-picker__content" }
const _hoisted_3 = { class: "el-time-range-picker__cell" }
const _hoisted_4 = { class: "el-time-range-picker__header" }
const _hoisted_5 = { class: "el-time-range-picker__cell" }
const _hoisted_6 = { class: "el-time-range-picker__header" }
const _hoisted_7 = { class: "el-time-panel__footer" }
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_time_spinner = _resolveComponent("time-spinner")!

  return (_ctx.actualVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t('Controls.DatePicker.StartTime')), 1),
            _createElementVNode("div", {
              class: _normalizeClass([{ 'has-seconds': _ctx.showSeconds, 'is-arrow': _ctx.arrowControl }, "el-time-range-picker__body el-time-panel__content"])
            }, [
              _createVNode(_component_time_spinner, {
                ref: "minSpinner",
                role: "start",
                "show-seconds": _ctx.showSeconds,
                "am-pm-mode": _ctx.amPmMode,
                "arrow-control": _ctx.arrowControl,
                "spinner-date": _ctx.minDate,
                "disabled-hours": _ctx.disabledHours_,
                "disabled-minutes": _ctx.disabledMinutes_,
                "disabled-seconds": _ctx.disabledSeconds_,
                onChange: _ctx.handleMinChange,
                onSetOption: _ctx.onSetOption,
                onSelectRange: _ctx.setMinSelectionRange
              }, null, 8, ["show-seconds", "am-pm-mode", "arrow-control", "spinner-date", "disabled-hours", "disabled-minutes", "disabled-seconds", "onChange", "onSetOption", "onSelectRange"])
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.t('Controls.DatePicker.EndTime')), 1),
            _createElementVNode("div", {
              class: _normalizeClass([{ 'has-seconds': _ctx.showSeconds, 'is-arrow': _ctx.arrowControl }, "el-time-range-picker__body el-time-panel__content"])
            }, [
              _createVNode(_component_time_spinner, {
                ref: "maxSpinner",
                role: "end",
                "show-seconds": _ctx.showSeconds,
                "am-pm-mode": _ctx.amPmMode,
                "arrow-control": _ctx.arrowControl,
                "spinner-date": _ctx.maxDate,
                "disabled-hours": _ctx.disabledHours_,
                "disabled-minutes": _ctx.disabledMinutes_,
                "disabled-seconds": _ctx.disabledSeconds_,
                onChange: _ctx.handleMaxChange,
                onSetOption: _ctx.onSetOption,
                onSelectRange: _ctx.setMaxSelectionRange
              }, null, 8, ["show-seconds", "am-pm-mode", "arrow-control", "spinner-date", "disabled-hours", "disabled-minutes", "disabled-seconds", "onChange", "onSetOption", "onSelectRange"])
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            class: "el-time-panel__btn cancel",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleCancel()))
          }, _toDisplayString(_ctx.t('Controls.DatePicker.Cancel')), 1),
          _createElementVNode("button", {
            type: "button",
            class: "el-time-panel__btn confirm",
            disabled: _ctx.btnConfirmDisabled,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleConfirm()))
          }, _toDisplayString(_ctx.t('Controls.DatePicker.Confirm')), 9, _hoisted_8)
        ])
      ]))
    : _createCommentVNode("", true)
}